import {TWalletNetwork} from '@/model/wallets/types/WalletNetwork'
import {networkMode, setNetworkMode} from '@/helpers/NetworkModeRegistry'

const MAINNET_ONLY_ROUTES = [
  'dappsOverview',
  'appsOverview',
  'dappDetailedView',
  'appDetailedView',
  'tokens',
  'nfts',
  'myWallet',
  'orbit',
  'advancedGasCalculator',
  'explorers',
  'exchanges',
  'wallets',
]

export abstract class NetworkModeHelper {
  static network(): TWalletNetwork {
    return networkMode()
  }

  static isTestnet(): boolean {
    return networkMode() === 'testnet'
  }

  static isRouteAvailable(routeName?: string | null): boolean {
    if (!this.isTestnet()) {
      return true
    }

    return !MAINNET_ONLY_ROUTES.includes(routeName ?? '')
  }

  /**
   * Switches without leaving the page: every CMS screen works on both networks.
   * The route check below is no help there anyway — the CMS reuses the site's
   * route names (`/orbit/list` is also called `orbit`), so it would throw the
   * admin out to the site's home page.
   */
  static switchToStayingHere(network: TWalletNetwork) {
    if (network === networkMode()) {
      return
    }

    setNetworkMode(network)
    window.location.reload()
  }

  static switchTo(network: TWalletNetwork, currentRouteName?: string | null) {
    if (network === networkMode()) {
      return
    }

    setNetworkMode(network)

    const keepsCurrentPage = this.isRouteAvailable(currentRouteName)

    if (keepsCurrentPage) {
      window.location.reload()
      return
    }

    window.location.assign('/')
  }
}
